import { AsxKatalLogger } from '@amzn/sss-website-theme';

const LOGGER_APP_NAME = 'AsxCreditsFrontendWebsite';

/**
 * KatalLogger instance for this React frontend. The same instance should be reused across the application.
 */
export const asxLogger = new AsxKatalLogger(LOGGER_APP_NAME);

export const {
  logger,
  emitMetric,
  emitCountMetric,
  emitTimeMetric,
  truncateContext,
  truncateError,
  toError,
  logError,
} = asxLogger;
